import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import update from 'immutability-helper';
import clsx from 'classnames';
//import moment from 'moment';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getGlobalClasses } from '../../themes';

//containers
import AuthUserContainer from '../../containers/AuthUser';

//- UI / Form
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Slide from '@material-ui/core/Slide';
import { green } from '@material-ui/core/colors';

//import SectionHeader from "../../components/SectionHeader";
//import CompanyDepartmentPicker from "../../components/advancedForm/CompanyDepartmentPicker";
import Note from '../../components/Note';
//import DownloadIcon from '@material-ui/icons/CloudDownload';
import SearchIcon from '@material-ui/icons/Search';
import CircularProgress from '@material-ui/core/CircularProgress';
import TmwCustomerSelect from '../../components/advancedForm/TmwCustomerSelect';
import localStorage from '../../libs/localStorage';
import TmwApi from '../../containers/Ticket/TmwApi';
import Table from '@material-ui/core/Table';
import EnhancedTableHead from '../../components/table/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import { PureRecordRow, sortTable } from '../../libs/tableUtilities';
//import TableRow from "@material-ui/core/TableRow";
import TableCell from '@material-ui/core/TableCell';
import { sampleUnbilledApiResult } from './sampleTmwOrders';
import copyToClipboardSvg from '../../images/icons/copyToClipboard.svg';
import twoDocumentsSvg from '../../images/icons/twoDocuments.svg';
import geoTabIcon from '../../images/icons/geoTabGIcon.svg';
import copyToClipboardSuccessSvg from '../../images/icons/copyToClipboardSuccess.svg';
import CheckIcon from '@material-ui/icons/Check';

import Popover from '@material-ui/core/Popover';
import UnbilledAddCommentDialog from '../../components/dialogs/UnbilledAddCommentDialog';
import FormDatePicker from '../../components/form/FormDatePicker';
import FormTimePicker from '../../components/form/FormTimePicker';
import TmwTerminalSelect from '../../components/advancedForm/TmwTerminalSelect';
import TmwDivisionSelect from '../../components/advancedForm/TmwDivisionSelect';
import UserPicker from '../../components/advancedForm/UserPicker';
import TmwInvoiceStatusSelect from '../../components/advancedForm/TmwInvoiceStatusSelect';
import FormControl from '@material-ui/core/FormControl';

import WarningIconSvg from '../../images/icons/warningIcon.svg';
import GreenChecked from '../../images/icons/greenChecked.svg';
import ImageZoomDialog from '../../components/dialogs/ImageZoomDialog';
import documentIcon from '../../images/document.svg';

const SlideUpTransition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const USE_TEST_DATA = false;

const linkColor = '#137EC2';
const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		submitButton: {
			marginTop: 20,
			fontSize: 16,
			borderRadius: '100px',
			padding: '13px 45px',
			textTransform: 'uppercase',
			marginRight: 10,
		},
		icon: {
			paddingRight: 5,
		},
		oddRow: {
			backgroundColor: '#f9f9f9',
		},
		linkedCells: {
			borderBottom: '1px dashed #f1f1f1',
			position: 'relative',
			padding: '6px 10px 6px 10px',
			cursor: 'pointer',
		},
		notLinked: {
			lineHeight: 1.4,
			padding: '6px 10px 6px 10px',
			cursor: 'pointer',
		},
		checkedCell: {
			backgroundColor: '#E8F5E9',
		},
		selectedCell: {
			borderTop: '2px solid #1289d4',
			borderBottom: '2px solid #1289d4',
			backgroundColor: '#E1F5FE',
		},
		notSelectedCell: {
			backgroundColor: '#E1F5FE',
		},
		linkedOrders: {
			borderLeft: `2px solid ${linkColor}`,
			position: 'absolute',
			left: 4,
			top: '39%',
			height: 60,
			'&::before': {
				position: 'absolute',
				top: 0,
				left: -6,
				height: 10,
				width: 10,
				background: linkColor,
				content: '""',
				borderRadius: 5,
			},
			'&::after': {
				position: 'absolute',
				top: 'auto',
				bottom: 0,
				left: -6,
				height: 10,
				width: 10,
				background: linkColor,
				content: '""',
				borderRadius: 5,
			},
		},
		resultsHere: {
			padding: 30,
			backgroundColor: '#f1f1f1',
			color: '#777',
			borderRadius: 10,
		},
		runningSearch: {
			paddingLeft: 20,
			display: 'flex',
			alignItems: 'center',
			fontSize: 18,
			color: '#666',
		},
		copyToClipboardIcon: {
			display: 'inline-block',
			width: 20,
			height: 20,
			backgroundImage: `url('${copyToClipboardSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginLeft: 5,
			cursor: 'pointer',
		},
		twoDocumentsIcon: {
			display: 'inline-block',
			width: 20,
			height: 20,
			backgroundImage: `url('${twoDocumentsSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginLeft: 5,
			cursor: 'pointer',
		},
		geoTabIcon: {
			display: 'inline-block',
			width: 15,
			height: 12,
			backgroundImage: `url('${geoTabIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginLeft: 5,
			cursor: 'pointer',
			marginBottom: 2,
		},
		geoTabLink: {
			textDecoration: 'none',
			borderBottom: '1px solid #1289d4',
		},
		copyToClipboardSuccessIcon: {
			display: 'inline-block',
			width: 20,
			height: 20,
			backgroundImage: `url('${copyToClipboardSuccessSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginLeft: 5,
			cursor: 'pointer',
		},

		snackbarSuccess: {
			backgroundColor: green[600],
		},
		snackbarIcon: {
			opacity: 0.9,
			marginRight: theme.spacing(1),
			fontSize: 20,
		},
		snackbarMessage: {
			display: 'flex',
			alignItems: 'center',
		},
		moveNumber: {
			fontSize: 13,
			color: '#999',
		},
		popover: {
			pointerEvents: 'none',
		},
		noComments: {
			borderRadius: 4,
			fontSize: 13,
			padding: '2px 9px',
			minWidth: 'auto',
			color: '#888',
			marginRight: 3,
		},
		hasComments: {
			borderRadius: 4,
			fontSize: 13,
			padding: '2px 9px',
			minWidth: 'auto',
			fontWeight: 600,
			marginRight: 3,
		},
		noRemarks: {
			borderRadius: 4,
			fontSize: 13,
			padding: '2px 9px',
			minWidth: 'auto',
			color: '#888',
			marginRight: 3,
		},
		hasRemarks: {
			borderRadius: 4,
			fontSize: 13,
			padding: '2px 9px',
			minWidth: 'auto',
			fontWeight: 600,
			marginRight: 3,
		},
		commentsContainer: {
			padding: 20,
		},
		commentContainer: {
			borderBottom: '1px solid #eee',
			marginBottom: 5,
			paddingBottom: 5,
		},
		commentDateTime: {
			fontSize: '80%',
			color: '#666',
		},
		customerLegend: {
			padding: 15,
			border: '1px solid #eee',
			marginBottom: 5,
		},
		legendInfo: {
			textTransform: 'uppercase',
			marginBottom: 5,
			letterSpacing: 1,
			color: '#666',
		},
		instructions: {
			padding: 20,
			color: '#444',
			fontWeight: 300,
		},
		shortCutSearchLink: {
			weight: 700,
			color: linkColor,
			cursor: 'pointer',
			border: '1px solid rgba(32,150,243,0)',
			transition: '0.3s',
			'&:hover': {
				border: '1px solid rgba(32,150,243,.8)',
				backgroundColor: `rgba(32,150,243,.2)`,
			},
		},
		wrappedList: {
			// height: 100,
			// display: 'flex',
			// flexDirection: 'column',
			// flexWrap: 'wrap',
			columnCount: 2,
		},
		regionContainer: {
			marginTop: 10,
		},
		regionTitle: {
			textTransform: 'uppercase',
			letterSpacing: 1,
			color: '#666',
			fontSize: '90%',
		},
		ticketStatusIcon: {
			display: 'inline-block',
			width: 24,
			height: 24,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
		},
		greenCheckedIcon: {
			backgroundImage: `url('${GreenChecked}')`,
		},
		smallWarningIcon: {
			backgroundImage: `url('${WarningIconSvg}')`,
		},
		ticketCommentSection: {
			marginTop: 7,
			paddingTop: 7,
			borderTop: '1px solid #ddd',
		},

		documentIcon: {
			marginRight: 12,
			display: 'inline-block',
			width: 21,
			height: 25,
			backgroundImage: `url('${documentIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			// cursor : 'pointer',
		},
	};
};

function formatBillToCompany(billToCompany) {
	let newCompanyName = billToCompany
		.toLowerCase()
		.split(' ')
		.map(function (i) {
			if (i.length > 2) {
				return i.charAt(0).toUpperCase() + i.substr(1);
			} else {
				return i.toUpperCase();
			}
		})
		.join(' ');
	newCompanyName = newCompanyName.replace('G & M', 'G&M');
	newCompanyName = newCompanyName.replace('Rtc', 'RTC');
	return newCompanyName;
}

const arrowUpKeyCode = 38;
const arrowDownKeyCode = 40;
const enterKeyCode = 13;

const DEFAULT_HOUR = 0;
const DEFAULT_MINUTE = 1;
const DEFAULT_DISPLAY = '12:01AM';

class UnbilledOrdersList extends Component {
	constructor(props) {
		super(props);
		let billToCustomerIds = localStorage.getItem(this.getStorageKey('billToCustomerIds')) || [];
		const terminalIds = localStorage.getItem(this.getStorageKey('terminalIds')) || [];
		const divisionIds = localStorage.getItem(this.getStorageKey('divisionIds')) || [];
		let orderStatuses = localStorage.getItem(this.getStorageKey('orderStatuses')) || [];

		let searchOnMount = false;

		let afterDate = moment().subtract(2, 'months').format('YYYY-MM-DD');
		let afterTime = moment(afterDate).hour(0).minute(0).format('YYYY-MM-DD HH:mm');
		if (_.get(this.props, 'match.params.afterDate')) {
			afterDate = _.get(this.props, 'match.params.afterDate');
			searchOnMount = true;
			afterTime = moment(afterDate).hour(0).minute(0).format('YYYY-MM-DD HH:mm');
		}

		let beforeDate = moment().format('YYYY-MM-DD');
		let beforeTime = moment(beforeDate)
			.hour(DEFAULT_HOUR)
			.minute(DEFAULT_MINUTE)
			.format('YYYY-MM-DD HH:mm');
		if (_.get(this.props, 'match.params.beforeDate')) {
			beforeDate = _.get(this.props, 'match.params.beforeDate');
			searchOnMount = true;
			beforeTime = moment(beforeDate).hour(23).minute(59).format('YYYY-MM-DD HH:mm');
		}

		const billTo = _.get(this.props, 'match.params.billTo');
		if (billTo) {
			billToCustomerIds = [billTo];
			searchOnMount = true;
			orderStatuses = [];
		}

		this.state = {
			formFieldError: {},
			isZoomOpen: false,

			//afterDate : moment().subtract(15, 'days').format('YYYY-MM-DD'),
			//beforeDate : moment().format('YYYY-MM-DD'),
			order: 'asc',
			orderBy: 'tmwOrderId',
			isSearching: false,
			beforeDate,
			beforeTime,
			afterDate,
			afterTime,
			billToCustomerIds,
			terminalIds,
			divisionIds,
			orderStatuses,
			searchOnMount,
			snackbarIsOpen: false,

			commentPopoverIsOpen: false,
			commentPopoverAnchor: undefined,
			popoverComments: [],
			popoverTickets: [],
			popoverOrderRemark: null,
			refreshId: 1,

			// - customer legend
			isSearchingForCurrent: true,
			checkedRows: {},
			selectedRowIndex: undefined,

			commentingOnTmwOrder: null,
		};
	}

	componentDidMount() {
		document.addEventListener('keydown', this.handleKeyDown);
		if (this.state.searchOnMount) {
			if (USE_TEST_DATA) {
				this.formatSearchResults({
					searchResult: sampleUnbilledApiResult,
				});
			} else {
				this.handleSearch();
			}
		}
		this.getCustomersWithCurrentOrders();
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleKeyDown);
	}

	handleKeyDown = (e) => {
		const { selectedRowIndex, rows } = this.state;
		if (!rows) {
			return;
		}

		const refreshId = this.state.refreshId + 1;
		if (_.isUndefined(selectedRowIndex)) {
			this.setState({
				selectedRowIndex: 0,
				refreshId,
			});
			return;
		}

		// arrow up/down button should select next/previous list element
		if (e.keyCode === arrowUpKeyCode && selectedRowIndex > 0) {
			this.setState({
				selectedRowIndex: selectedRowIndex - 1,
				refreshId,
			});
		} else if (e.keyCode === arrowDownKeyCode && selectedRowIndex < rows.length - 1) {
			this.setState({
				selectedRowIndex: selectedRowIndex + 1,
				refreshId,
			});
		} else if (e.keyCode === enterKeyCode) {
			this.copySelectedRowToClipBoard();
		}
	};

	getStorageKey(key) {
		return `/unbilledOrders-${key}`;
	}

	componentDidUpdate(prevProps, prevState, snapShot) {
		const { searchResultTmwOrders, order, orderBy } = this.state;

		if (
			searchResultTmwOrders !== prevState.searchResultTmwOrders ||
			order !== prevState.order ||
			orderBy !== prevState.orderBy
		) {
			this.sortAndFlattenRows();
		}
	}

	//- Path is always a string
	//- value is never an event (value.target)
	onChange = (value, path, error) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);

		if (error) {
			formFieldError[path] = error;
		} else {
			delete formFieldError[path];
		}
		newState.formFieldError = formFieldError;

		if (
			path === 'billToCustomerIds' ||
			path === 'terminalIds' ||
			path === 'divisionIds' ||
			path === 'orderStatuses'
		) {
			localStorage.setItem(this.getStorageKey(path), value);
		}
		this.setState(newState);
	};

	getApiParams = () => {
		const { accessToken } = this.props;

		const {
			billToCustomerIds,
			terminalIds,
			divisionIds,
			orderStatuses,
			driverName,
			afterDate,
			afterTime,
			beforeDate,
			beforeTime,
		} = this.state;

		const afterMoment = moment(afterDate);
		const at = moment(afterTime);
		afterMoment.hour(at.hour()).minute(at.minute());

		const beforeMoment = moment(beforeDate);
		const bt = moment(beforeTime);
		beforeMoment.hour(bt.hour()).minute(bt.minute());

		return {
			accessToken,
			billToCustomerIds,
			terminalIds,
			divisionIds,
			orderStatuses,
			driverName,
			afterDateTime: afterMoment.utc().format('YYYY-MM-DD HH:mm'),
			beforeDateTime: beforeMoment.utc().format('YYYY-MM-DD HH:mm'),
		};
	};

	handleSearch = () => {
		const { searchUnbilledOrders, showErrors } = this.props;

		const formFieldError = {};
		const requiredFields = [
			{ path: 'billToCustomerIds', label: 'Bill to customers' },
			{ path: 'beforeTime', label: 'Before Time' },
			{ path: 'afterTime', label: 'After Time' },
		];

		requiredFields.forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//const {} = this.state;

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const params = this.getApiParams();
		this.setState({
			isSearching: true,
		});

		searchUnbilledOrders({
			params,
			callback: (err, r) => {
				this.setState({ isSearching: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}
				this.formatSearchResults({
					searchResult: r,
				});
			},
		});
	};

	getCustomersWithCurrentOrders = () => {
		const { searchUnbilledOrders, showErrors } = this.props;

		this.setState({
			isSearchingForCurrent: true,
		});

		searchUnbilledOrders({
			params: {
				afterDateTime: moment().subtract(30, 'days').utc().format('YYYY-MM-DD HH:mm'),
				beforeDateTime: moment()
					.hour(DEFAULT_HOUR)
					.minute(DEFAULT_MINUTE)
					.utc()
					.format('YYYY-MM-DD HH:mm'),
			},
			callback: (err, r) => {
				this.setState({ isSearchingForCurrent: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				this.formatCustomersWithCurrentOrdersSearchResults({
					searchResult: r,
				});
			},
		});
	};

	formatCustomersWithCurrentOrdersSearchResults = ({ searchResult }) => {
		const tmwOrders = _.get(searchResult, 'tmwOrders', []);
		const ordersByRegionByCustomer = {
			northwest: {},
			southwest: {},
			'pacific northwest': {},
			other: {},
		};
		const ordersByTerminal = {};
		const billToFilter = [];
		const terminalFilter = [];
		tmwOrders.forEach((tmwOrder) => {
			const { billTo, billToCompany, terminal } = tmwOrder;
			if (!_.isString(billTo)) {
				return;
			}

			let region; // = 'other';
			if (billTo.match(/NW$/)) {
				region = 'northwest';
			} else if (billTo === 'SUNPAC') {
				region = 'pacific northwest';
			} else {
				// } else if (billTo.match(/SW$/)) {
				region = 'southwest';
			}

			if (!ordersByRegionByCustomer[region][billTo]) {
				ordersByRegionByCustomer[region][billTo] = {
					billToCompany,
					billTo,
					count: 0,
				};
			}
			ordersByRegionByCustomer[region][billTo].count++;
			billToFilter.push(billTo);

			if (!ordersByTerminal[terminal]) {
				ordersByTerminal[terminal] = {
					terminal,
					count: 0,
				};
			}
			ordersByTerminal[terminal].count++;
			terminalFilter.push(terminal);
		});

		const customersByRegion = {};
		_.keys(ordersByRegionByCustomer).forEach((region) => {
			customersByRegion[region] = _.sortBy(
				_.values(ordersByRegionByCustomer[region]),
				'billToCompany'
			);
		});

		this.setState({
			billToFilter,
			terminalFilter,
			customersByRegion,
			terminalOrderRows: _.sortBy(_.values(ordersByTerminal), 'terminal'),
		});
	};

	formatCommentsByTmwOrderId = ({ apiResult }) => {
		const userMap = _.keyBy(_.get(apiResult, 'collections.userCollection', []), 'userId');

		const commentsByTmwOrderId = {};
		const allComments = _.get(apiResult, 'collections.tmwOrderCommentCollection', []);
		_.orderBy(allComments, 'dateCreated', 'asc').forEach((comment) => {
			const { tmwOrderId, dateCreated, createdByUserId } = comment;
			const user = userMap[createdByUserId] || { firstName: 'Unknown' };

			comment.userDisplay = `${user.firstName} ${user.lastName}`;
			comment.dateTimeFormatted = moment(dateCreated).format('M/D h:mm a');

			if (!commentsByTmwOrderId[tmwOrderId]) {
				commentsByTmwOrderId[tmwOrderId] = [];
			}
			commentsByTmwOrderId[tmwOrderId].push(comment);
		});
		return commentsByTmwOrderId;
	};

	formatTicketsByTmwOrderId = ({ apiResult }) => {
		const { collections } = apiResult;
		if (!_.isObject(collections)) {
			return;
		}
		const { userCollection, ticketCategoryCollection } = collections;
		const userMap = _.keyBy(userCollection, 'userId');
		const ticketCategoryMap = _.keyBy(ticketCategoryCollection, 'ticketCategoryId');

		const ticketsByTmwOrderId = {};
		const allTickets = _.get(apiResult, 'collections.ticketCollection', []);
		_.orderBy(allTickets, 'dateCreated', 'asc').forEach((ticket) => {
			const { schemaValues, dateCreated, creatorUserId, ticketCategoryId } = ticket;

			if (!_.isObject(schemaValues)) {
				return;
			}
			const { tmwOrderId, details } = schemaValues;
			if (!tmwOrderId) {
				return;
			}

			const user = userMap[creatorUserId] || { firstName: 'Unknown' };
			const ticketCategory = ticketCategoryMap[ticketCategoryId] || { displayName: 'Missing' };

			ticket.userDisplay = `${user.firstName} ${user.lastName}`;
			ticket.categoryDisplay = ticketCategory.displayName;
			ticket.dateTimeFormatted = moment(dateCreated).format('M/D h:mm a');
			ticket.details = details;

			console.log('TICKET', ticket);

			if (!_.isEmpty(ticket.comments)) {
				ticket.comments.forEach((comment) => {
					const { dateCreated, creatorUserId } = comment;
					const user = userMap[creatorUserId] || { firstName: 'Unknown' };
					comment.userDisplay = `${user.firstName} ${user.lastName}`;
					comment.dateTimeFormatted = moment(dateCreated).format('M/D h:mm a');
				});
			} else {
				ticket.comments = [];
			}

			if (!ticketsByTmwOrderId[tmwOrderId]) {
				ticketsByTmwOrderId[tmwOrderId] = [];
			}
			ticketsByTmwOrderId[tmwOrderId].push(ticket);
		});
		return ticketsByTmwOrderId;
	};

	formatSearchResults = ({ searchResult }) => {
		const { classes } = this.props;
		const tmwOrders = _.get(searchResult, 'tmwOrders', []);

		const commentsByTmwOrderId = this.formatCommentsByTmwOrderId({
			apiResult: searchResult,
		});

		const ticketsByTmwOrderId = this.formatTicketsByTmwOrderId({
			apiResult: searchResult,
		});

		const ordersGroupByMoveNumber = {};
		tmwOrders.forEach((tmwOrder) => {
			const { moveNumber } = tmwOrder;

			if (!ordersGroupByMoveNumber[moveNumber]) {
				ordersGroupByMoveNumber[moveNumber] = [];
			}
			ordersGroupByMoveNumber[moveNumber].push(tmwOrder);

			const shipDateDisplay = moment(tmwOrder.shipDate).format('M/D h:mm a');
			const completionDateDisplay = moment(tmwOrder.completionDate).format('M/D h:mm a');

			tmwOrder.statusesDisplay = (
				<div>
					<div>Order : {tmwOrder.orderStatus}</div>
					{tmwOrder.invoiceStatus && <div>Invoice : {tmwOrder.invoiceStatus}</div>}
				</div>
			);

			tmwOrder.shipDateDisplay = shipDateDisplay;
			tmwOrder.completionDateDisplay = completionDateDisplay;

			tmwOrder.billToConsignee = (
				<div>
					<div>{tmwOrder.billToCompany}</div>
					<div>{tmwOrder.consigneeCompany}</div>
				</div>
			);

			const { bolNumber, sidNumber, customerRef } = tmwOrder;
			tmwOrder.refDisplay = (
				<div>
					{!!bolNumber && <div>BOL : {bolNumber}</div>}
					{!!sidNumber && <div>SID : {sidNumber}</div>}
					{!!customerRef && <div>CUST : {customerRef}</div>}
				</div>
			);
			tmwOrder.refSort = bolNumber
				? bolNumber
				: customerRef
				? customerRef
				: sidNumber
				? sidNumber
				: '';

			tmwOrder.hasSplitDisplay = tmwOrder.splitCount >= 2 ? <CheckIcon /> : '-';
			//tmwOrder.hasStopDisplay = (tmwOrder.stopCount >= 1)  ? <CheckIcon />  : '-';

			//- comments
			tmwOrder.tmwOrderComments = commentsByTmwOrderId[tmwOrder.tmwOrderId] || [];
			tmwOrder.tickets = ticketsByTmwOrderId[tmwOrder.tmwOrderId] || [];
			tmwOrder.allTicketsComplete = _.every(tmwOrder.tickets, { status: 'complete' });
			if (!_.isEmpty(tmwOrder.tickets)) {
				tmwOrder.ticketUrl = '/ticket/update/' + _.first(tmwOrder.tickets).ticketId;
			}

			tmwOrder.ticketCount = tmwOrder.tickets.length;
			tmwOrder.commentCount = tmwOrder.tmwOrderComments.length;

			const { driverUrl, equipmentUrl, driverName, truckName } = tmwOrder;
			const { geoTabLink, geoTabIcon } = classes;
			tmwOrder.geoTabDisplay = (
				<>
					<div>
						{driverUrl && (
							<a
								href={driverUrl}
								className={geoTabLink}
								target="_blank"
								rel="noreferrer noopener"
								onClick={this.noClick}
							>
								{driverName} <span className={geoTabIcon} />
							</a>
						)}
						{!driverUrl && driverName}
					</div>
					<div>
						{equipmentUrl && (
							<a
								href={equipmentUrl}
								className={geoTabLink}
								target="_blank"
								rel="noreferrer noopener"
								onClick={this.noClick}
							>
								{truckName} <span className={geoTabIcon} />
							</a>
						)}
						{!equipmentUrl && truckName}
					</div>
				</>
			);
		});

		const searchResultTmwOrders = [];
		_.values(ordersGroupByMoveNumber).forEach((rows) => {
			const mainTmwOrder = rows.pop();
			if (!_.isEmpty(rows)) {
				mainTmwOrder.linkedTmwOrders = rows;
			}
			searchResultTmwOrders.push(mainTmwOrder);
		});

		this.setState({
			searchResultTmwOrders,
			savingStatus: 'done',
		});
	};

	sortAndFlattenRows = () => {
		const { searchResultTmwOrders, order, orderBy } = this.state;
		const rows = sortTable({
			rows: searchResultTmwOrders,
			order,
			orderBy,
			secondaryOrderBy: 'driverName',
		});

		const { classes } = this.props;
		const finalRows = [];
		rows.forEach((row, i) => {
			const rowClass = i % 2 ? classes.oddRow : null;

			let allOrders = [row];
			if (!_.isEmpty(row.linkedTmwOrders)) {
				allOrders = allOrders.concat(row.linkedTmwOrders);
			}

			allOrders.forEach((order, j) => {
				order.rowClass = rowClass;

				if (allOrders.length > 1 && j !== allOrders.length - 1) {
					order.showLink = true;
				}
				finalRows.push(order);
			});
		});
		this.setState({
			refreshId: this.state.refreshId + 1,
			rows: finalRows,
		});
	};

	getInputProps = (path, defaultValue) => {
		return {
			key: path,
			path,
			value: this.getValue(path, defaultValue),
			checked: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
			gridProps: { md: 12 },
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	showZoomImageDialog = (imageUrls, tmwOrderId) => {
		this.setState({ isZoomOpen: true, imageUrls, tmwOrderIdForImageZoom: tmwOrderId });
	};
	hideZoomImageDialog = () => {
		this.setState({
			imageUrls: undefined,
			tmwOrderIdForImageZoom: undefined,
			isZoomOpen: false,
		});
	};

	render() {
		const { classes } = this.props;

		const { isSearching, rows, isSearchingForCurrent } = this.state;

		/*
		const params = this.getApiParams();
		params.downloadCsv = true;
		const request = {
			method: 'unbilledOrders.search',
			params
		};
		const downloadUrl = `/api?request=${JSON.stringify(request)}`;
		*/

		const {
			billToFilter,
			terminalFilter,
			commentingOnTmwOrder,
			popoverOrderRemark,
			popoverComments,
			popoverTickets,
		} = this.state;
		return (
			<form>
				<Accordion
					defaultExpanded={true}
					className={classes.globalMainPaper}
					style={{ paddingBottom: 20 }}
				>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1a-content"
						id="panel1a-header"
					>
						<div className={classes.globalMainHeadline}>Unbilled Order Search</div>
					</AccordionSummary>
					<AccordionDetails>
						<Grid spacing={2} container>
							<Grid item xs={12} sm={12} md={8} lg={8}>
								<Grid spacing={2} container>
									<Grid item xs={12}>
										<Note type={'info'}>Page will remember your settings between visits</Note>
									</Grid>

									{!billToFilter && (
										<Grid item xs={12}>
											<FormControl fullWidth={true}>
												Fetching customers as of {DEFAULT_DISPLAY}..
											</FormControl>
										</Grid>
									)}

									{billToFilter && (
										<TmwCustomerSelect
											{...this.getInputProps('billToCustomerIds')}
											label={'Bill To Customer (leave empty for all)'}
											billToFilter={billToFilter}
										/>
									)}

									{!terminalFilter && (
										<Grid item xs={12}>
											<FormControl fullWidth={true}>
												Fetching terminals as of {DEFAULT_DISPLAY}..
											</FormControl>
										</Grid>
									)}

									{terminalFilter && (
										<TmwTerminalSelect
											{...this.getInputProps('terminalIds')}
											label={'Terminal'}
											gridProps={{ md: 12 }}
											terminalFilter={terminalFilter}
										/>
									)}

									<TmwDivisionSelect
										{...this.getInputProps('divisionIds')}
										label={'Division'}
										gridProps={{ md: 12 }}
									/>

									<UserPicker
										{...this.getInputProps('driverName')}
										label={'Driver'}
										useGeoTabNameAsValue={true}
										gridProps={{ md: 6 }}
									/>

									<TmwInvoiceStatusSelect
										{...this.getInputProps('orderStatuses')}
										label={'TMW Order Statuses'}
										useOrderStatuses={true}
										gridProps={{ md: 6 }}
									/>

									<FormDatePicker
										{...this.getInputProps('afterDate')}
										label="After date"
										format={'M/D/YYYY'}
										gridProps={{ md: 3 }}
									/>

									<FormTimePicker
										{...this.getInputProps('afterTime')}
										label="After time"
										gridProps={{ md: 3 }}
									/>

									<FormDatePicker
										{...this.getInputProps('beforeDate')}
										label="Before date"
										format={'M/D/YYYY'}
										gridProps={{ md: 3 }}
									/>

									<FormTimePicker
										{...this.getInputProps('beforeTime')}
										label="Before time"
										gridProps={{ md: 3 }}
									/>

									<Grid item xs={12} style={{ padding: '20px 0px', display: 'flex' }}>
										<Button
											onClick={this.handleSearch}
											variant="contained"
											color="primary"
											className={classes.submitButton}
										>
											<SearchIcon className={classes.icon} />
											Search
										</Button>

										{isSearching && (
											<div className={classes.runningSearch}>
												<CircularProgress />
												<span style={{ paddingLeft: 10 }}>Searching...</span>
											</div>
										)}
									</Grid>
								</Grid>
							</Grid>
							<Grid item xs={12} md={4}>
								<div className={classes.customerLegend}>
									<div className={classes.legendInfo}>
										Unbilled customers as of {DEFAULT_DISPLAY} today
									</div>
									<div>
										{isSearchingForCurrent && <CircularProgress />}
										{!isSearchingForCurrent && this.renderCustomerLegend()}
									</div>
								</div>

								<div className={classes.customerLegend}>
									<div className={classes.legendInfo}>
										Unbilled terminals as of {DEFAULT_DISPLAY} today
									</div>
									<div>
										{isSearchingForCurrent && <CircularProgress />}
										{!isSearchingForCurrent && this.renderTerminalLegend()}
									</div>
								</div>
							</Grid>
						</Grid>
					</AccordionDetails>
				</Accordion>

				<Paper className={classes.globalMainPaper}>
					{_.isUndefined(rows) && <div className={classes.resultsHere}>Results here</div>}
					{!_.isUndefined(rows) && (
						<div>
							<div className={classes.instructions}>
								Click on a row to copy the TMW # to the clipboard and select that row. Once you have
								selected a row you can navigate up and down using you arrow keys and can copy to the
								clipboard with the return key.
							</div>
							{this.renderResults()}
						</div>
					)}
				</Paper>

				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					open={this.state.snackbarIsOpen}
					autoHideDuration={2000}
					onClose={this.handleSnackbarClose}
					TransitionComponent={SlideUpTransition}
				>
					<SnackbarContent
						className={classes.snackbarSuccess}
						aria-describedby="client-snackbar"
						message={
							<span id="client-snackbar" className={classes.snackbarMessage}>
								<CheckCircleIcon className={classes.snackbarIcon} />
								<strong>{this.state.snackbarMessage} </strong>&nbsp;copied to clipboard
							</span>
						}
						action={[
							<IconButton
								key="close"
								aria-label="close"
								color="inherit"
								onClick={this.handleSnackbarClose}
							>
								<CloseIcon className={classes.icon} />
							</IconButton>,
						]}
					/>
				</Snackbar>

				<Popover
					id="comment-popover"
					className={classes.popover}
					classes={{
						paper: classes.paper,
					}}
					open={!!this.state.commentPopoverAnchor}
					anchorEl={this.state.commentPopoverAnchor}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					onClose={this.state.handleCommentPopoverClose}
					disableRestoreFocus
				>
					<div className={classes.commentsContainer}>
						{popoverOrderRemark && (
							<div className={classes.commentContainer}>
								<div style={{ whiteSpace: 'pre-line' }}>
									<strong>TMW Remark </strong>"{popoverOrderRemark}"
								</div>
							</div>
						)}

						{!_.isEmpty(popoverComments) &&
							popoverComments.map((comment) => {
								const { tmwOrderCommentId, commentText, userDisplay, dateTimeFormatted } = comment;
								return (
									<div key={tmwOrderCommentId} className={classes.commentContainer}>
										<div style={{ whiteSpace: 'pre-line' }}>
											<strong>{userDisplay} </strong>said "{commentText}"
										</div>
										<div className={classes.commentDateTime}>{dateTimeFormatted}</div>
									</div>
								);
							})}

						{!_.isEmpty(popoverTickets) &&
							popoverTickets.map((ticket) => {
								const {
									ticketId,
									details,
									categoryDisplay,
									userDisplay,
									dateTimeFormatted,
									comments,
									status,
								} = ticket;
								return (
									<div key={ticketId} className={classes.commentContainer}>
										<div style={{ whiteSpace: 'pre-line' }}>
											<strong>{categoryDisplay} Ticket</strong> opened by {userDisplay}
										</div>
										<div>Ticket Status : {status}</div>
										<div style={{ whiteSpace: 'pre-line' }}>{details}</div>
										<div className={classes.commentDateTime}>{dateTimeFormatted}</div>
										{!_.isEmpty(comments) && (
											<div className={classes.ticketCommentSection}>
												{comments.map((comment) => {
													const { ticketCommentId, userDisplay, dateTimeFormatted } = comment;
													console.log('COMMENT', comment);
													return (
														<div key={ticketCommentId} className={classes.commentContainer}>
															<div style={{ whiteSpace: 'pre-line' }}>
																<strong>{userDisplay} </strong>said "{comment.comment}"
															</div>
															<div className={classes.commentDateTime}>{dateTimeFormatted}</div>
														</div>
													);
												})}
											</div>
										)}
									</div>
								);
							})}
					</div>
				</Popover>

				<UnbilledAddCommentDialog
					open={Boolean(commentingOnTmwOrder)}
					onClose={this.handleCloseCommentDialog}
					tmwOrder={commentingOnTmwOrder}
					afterSave={this.afterSaveComment}
				/>

				<ImageZoomDialog
					open={this.state.isZoomOpen}
					onClose={this.hideZoomImageDialog}
					imageUrls={this.state.imageUrls}
					tmwOrderId={this.state.tmwOrderIdForImageZoom}
				/>
			</form>
		);
	}

	handleShortcutSearch = ({ billTo, terminal }) => {
		const newState = {};
		if (billTo) {
			newState.billToCustomerIds = [billTo];
		}
		if (terminal) {
			newState.terminalIds = [terminal];
		}
		this.setState(newState, this.handleSearch);
	};

	renderCustomerLegend = () => {
		const { classes } = this.props;
		const { customersByRegion } = this.state;
		if (!customersByRegion) {
			return 'Fetching...';
		}

		return (
			<>
				{['northwest', 'southwest', 'pacific northwest'].map((region) => {
					const customers = customersByRegion[region];
					return (
						<div key={region} className={classes.regionContainer}>
							<div className={classes.regionTitle}>{_.capitalize(region)}</div>

							<div style={{ marginLeft: 5 }}>
								{_.isEmpty(customers) && (
									<div style={{ color: '#aaa', fontStyle: 'italic' }}>none</div>
								)}
								{_.orderBy(customers, 'billToCompany').map((customer) => {
									const { billToCompany, billTo, count } = customer;
									return (
										<div
											key={billTo}
											onClick={() => {
												this.handleShortcutSearch({ billTo });
											}}
											className={classes.shortCutSearchLink}
										>
											{formatBillToCompany(billToCompany)} - <strong>{count}</strong>
										</div>
									);
								})}
							</div>
						</div>
					);
				})}
			</>
		);
	};

	renderTerminalLegend = () => {
		const { classes } = this.props;
		const { terminalOrderRows } = this.state;
		if (!terminalOrderRows) {
			return 'Fetching...';
		}
		return (
			<div className={classes.wrappedList}>
				<ul style={{ margin: 0 }}>
					{terminalOrderRows.map((terminalOrderRow) => {
						const { terminal, count } = terminalOrderRow;
						return (
							<li
								key={terminal}
								onClick={() => {
									this.handleShortcutSearch({ terminal });
								}}
								className={classes.shortCutSearchLink}
							>
								{terminal} - <strong>{count}</strong>
							</li>
						);
					})}
				</ul>
			</div>
		);
	};

	afterSaveComment = ({ apiResult }) => {
		const { searchResultTmwOrders } = this.state;
		const commentsByTmwOrderId = this.formatCommentsByTmwOrderId({
			apiResult,
		});

		const allComments = _.first(_.values(commentsByTmwOrderId)) || [];
		const newComment = _.first(allComments);
		if (!newComment) {
			return console.error('Could not find newComment', commentsByTmwOrderId, apiResult);
		}

		const { tmwOrderId } = newComment;
		const currentIndex = _.findIndex(searchResultTmwOrders, { tmwOrderId });

		if (currentIndex === -1) {
			console.error('Could not find order to add comment to', tmwOrderId, searchResultTmwOrders);
			return;
		}

		const newSearchResultTmwOrders = update(searchResultTmwOrders, {
			[currentIndex]: {
				tmwOrderComments: { $push: [newComment] },
			},
		});
		this.setState({
			searchResultTmwOrders: newSearchResultTmwOrders,
			refreshId: this.state.refreshId + 1,
		});
	};

	handleAddComment = (order) => {
		this.setState({ commentingOnTmwOrder: order });
	};
	handleCloseCommentDialog = () => {
		this.setState({ commentingOnTmwOrder: null });
	};

	handleCommentPopoverOpen = (event, tmwOrderComments) => {
		this.setState({
			popoverOrderRemark: null,
			popoverComments: tmwOrderComments,
			popoverTickets: [],
			commentPopoverAnchor: event.currentTarget,
		});
	};
	handleCommentPopoverClose = () => {
		this.setState({ commentPopoverAnchor: null });
	};

	handleTicketPopoverOpen = (event, tickets) => {
		this.setState({
			popoverOrderRemark: null,
			popoverComments: [],
			popoverTickets: tickets,
			commentPopoverAnchor: event.currentTarget,
		});
	};
	handleTicketPopoverClose = () => {
		this.setState({ commentPopoverAnchor: null });
	};

	handleRemarkPopoverOpen = (event, popoverOrderRemark) => {
		this.setState({
			popoverOrderRemark,
			popoverComments: [],
			popoverTickets: [],
			commentPopoverAnchor: event.currentTarget,
		});
	};
	handleRemarkPopoverClose = () => {
		this.setState({ commentPopoverAnchor: null });
	};

	handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({ snackbarIsOpen: false });
	};

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order: order, orderBy: orderBy });
	};

	renderResults = () => {
		const { classes } = this.props;
		const { order, orderBy, rows } = this.state;

		const columns = [
			{
				id: 'tmwOrderId',
				label: 'TMW #',
			},
			{
				id: 'ticketCount',
				label: 'Ticket',
			},
			{
				id: 'shipDate',
				label: 'Ship Date',
			},
			{
				id: 'completionDate',
				label: 'Delivery Date',
				// }, {
				//	id: 'division',
				//	label: 'Division',
				//}, {
				//	id: 'terminal',
				//	label: 'Terminal',
			},
			{
				id: 'billTo',
				labels: ['Bill To', 'Consignee (Site)'],
				//}, {
				//	id: 'refSort',
				//	label: 'Ref',
			},
			{
				id: 'images',
				labels: ['Mobile', 'Scan'],
			},
			{
				id: 'driverName',
				labels: ['GeoTab', 'Links'],
			},
			{
				id: 'rateHint',
				label: 'Rate Hint',
			},
			{
				id: 'splitCount',
				label: 'Split',
			},
			{
				id: 'statusesDisplay',
				label: 'Statuses',
			},
			{
				id: 'commentCount',
				labels: ['Comments', 'Remarks'],
			},
		];

		return (
			<>
				<div>
					<Button variant="contained" color="primary" onClick={this.copyRowsToClipboard}>
						Copy {rows.length} TMW #'s to clipboard
					</Button>
				</div>
				<Table size="small" className={classes.table}>
					<EnhancedTableHead
						columns={columns}
						order={order}
						orderBy={orderBy}
						onRequestSort={this.handleSort}
					/>
					<TableBody>
						{rows.map((order, i) => {
							const { rowClass, showLink } = order;

							let cellClasses = [classes.notLinked];
							if (showLink) {
								cellClasses = [classes.linkedCells];
							}

							const { tmwOrderId } = order;
							let clipboardClass = classes.copyToClipboardIcon;
							if (this.state.checkedRows[tmwOrderId]) {
								clipboardClass = classes.copyToClipboardSuccessIcon;
								cellClasses.push(classes.checkedCell);
							}

							if (this.state.selectedRowIndex === i) {
								cellClasses.push(classes.selectedCell);
							}
							//else {
							//	cellClasses.push(classes.notSelectedCell);
							//}

							const {
								tmwOrderComments,
								tickets,
								ticketUrl,
								allTicketsComplete,
								ticketCount,
								orderRemark,
							} = order;
							let commentDisplay;
							if (_.isEmpty(tmwOrderComments)) {
								commentDisplay = (
									<div>
										<Button size="small" variant="outlined" className={classes.noComments} disabled>
											0
										</Button>
									</div>
								);
							} else {
								commentDisplay = (
									<div
										aria-haspopup="true"
										onMouseEnter={(event) => {
											this.handleCommentPopoverOpen(event, tmwOrderComments);
										}}
										onMouseLeave={this.handleCommentPopoverClose}
									>
										<Button
											size="small"
											variant="outlined"
											color="primary"
											className={classes.hasComments}
										>
											{tmwOrderComments.length}
										</Button>
									</div>
								);
							}

							let ticketDisplay;
							if (_.isEmpty(tickets)) {
								ticketDisplay = '-';
							} else {
								ticketDisplay = (
									<div
										aria-haspopup="true"
										onMouseEnter={(event) => {
											this.handleTicketPopoverOpen(event, tickets);
										}}
										onMouseLeave={this.handleTicketPopoverClose}
									>
										<a
											href={ticketUrl}
											target="_blank"
											rel="noreferrer noopener"
											onClick={this.noClick}
										>
											<span>{ticketCount} x </span>
											{allTicketsComplete && (
												<span
													className={clsx(classes.ticketStatusIcon, classes.greenCheckedIcon)}
												/>
											)}
											{!allTicketsComplete && (
												<span
													className={clsx(classes.ticketStatusIcon, classes.smallWarningIcon)}
												/>
											)}
										</a>
									</div>
								);
							}

							let remarkDisplay;
							if (!orderRemark) {
								remarkDisplay = (
									<div>
										<Button size="small" variant="outlined" className={classes.noRemarks} disabled>
											0
										</Button>
									</div>
								);
							} else {
								remarkDisplay = (
									<div
										aria-haspopup="true"
										onMouseEnter={(event) => {
											this.handleRemarkPopoverOpen(event, orderRemark);
										}}
										onMouseLeave={this.handleRemarkPopoverClose}
									>
										<Button
											size="small"
											variant="outlined"
											color="primary"
											className={classes.hasRemarks}
										>
											1
										</Button>
									</div>
								);
							}

							const rowClick = () => {
								this.setState(
									{
										selectedRowIndex: i,
									},
									() => {
										this.copySelectedRowToClipBoard();
									}
								);
							};

							// Old does not work
							//const docUrl =
							//	'http://192.168.0.211/cgi-bin/img-docfind.pl?qtype=Search%20On%20One%20Index' +
							//	`&reftype=ORD&refnum=${order.tmwOrderId}#`;
							const documents = order.scannedDocuments || [];
							const documentDisplay = _.isEmpty(documents) ? (
								'-'
							) : (
								<div
									style={{
										position: 'relative',
										marginBottom: '20px',
									}}
									onClick={() => {
										this.showZoomImageDialog(
											documents.map((d) => d.url),
											tmwOrderId
										);
									}}
								>
									{documents.map((document, i) => {
										return (
											<div
												key={document.url}
												className={classes.documentIcon}
												style={{ position: 'absolute', left: i * 7 }}
											/>
										);
									})}
								</div>
							);

							return (
								<PureRecordRow
									hover
									className={rowClass}
									key={order.tmwOrderId}
									refreshId={this.state.refreshId}
								>
									<TableCell className={clsx(cellClasses)}>
										<div style={{ display: 'flex', paddingLeft: 5 }}>
											{showLink && <div className={classes.linkedOrders} />}
											<div>
												<div>{order.tmwOrderId}</div>
											</div>
											<div className={clipboardClass} onClick={rowClick} />
										</div>
									</TableCell>

									<TableCell
										className={clsx(cellClasses)}
										align="center"
										style={{ whiteSpace: 'nowrap' }}
									>
										<div style={{ display: 'flex', alignItems: 'center' }}>{ticketDisplay}</div>
									</TableCell>

									<TableCell className={clsx(cellClasses)} onClick={rowClick}>
										{order.shipDateDisplay}
									</TableCell>
									<TableCell className={clsx(cellClasses)} onClick={rowClick}>
										{order.completionDateDisplay}
									</TableCell>
									{/*
								<TableCell className={clsx(cellClasses)} onClick={rowClick}>
									{order.division}
								</TableCell>
								<TableCell className={clsx(cellClasses)} onClick={rowClick}>
									{order.terminal}
								</TableCell>
								*/}
									<TableCell className={clsx(cellClasses)} onClick={rowClick}>
										{order.billToConsignee}
									</TableCell>
									{/*
								<TableCell className={clsx(cellClasses)} onClick={rowClick}>
									{order.refDisplay}
								</TableCell>
								*/}

									<TableCell className={clsx(cellClasses)}>{documentDisplay}</TableCell>
									<TableCell className={clsx(cellClasses)} onClick={rowClick}>
										{order.geoTabDisplay}
									</TableCell>
									<TableCell className={clsx(cellClasses)} onClick={rowClick}>
										<strong>{order.rateHintDisplay}</strong>
									</TableCell>
									<TableCell className={clsx(cellClasses)}>{order.hasSplitDisplay}</TableCell>
									<TableCell className={clsx(cellClasses)}>{order.statusesDisplay}</TableCell>
									<TableCell
										className={clsx(cellClasses)}
										align="center"
										style={{ whiteSpace: 'nowrap' }}
									>
										<div style={{ display: 'flex', alignItems: 'center' }}>
											{remarkDisplay}
											{commentDisplay}
											<Button
												className={classes.button}
												onClick={() => this.handleAddComment(order)}
											>
												Add
											</Button>
										</div>
									</TableCell>
								</PureRecordRow>
							);
						})}
					</TableBody>
				</Table>
			</>
		);
	};

	noClick = (e) => {
		e.stopPropagation();
	};

	copySelectedRowToClipBoard = () => {
		const { selectedRowIndex, rows, checkedRows } = this.state;
		if (_.isUndefined(selectedRowIndex) || !rows) {
			return;
		}

		const tmwOrderId = _.get(rows[selectedRowIndex], 'tmwOrderId');

		this.setState({
			checkedRows: { ...checkedRows, [tmwOrderId]: true },
			refreshId: this.state.refreshId + 1,
			snackbarMessage: tmwOrderId,
			snackbarIsOpen: true,
		});
		if (!navigator.clipboard) {
			this.fallbackCopyTextToClipboard(tmwOrderId);
			return;
		}
		navigator.clipboard.writeText(tmwOrderId).then(
			function () {},
			function (err) {
				console.error('Async: Could not copy text: ', err);
			}
		);
	};

	copyRowsToClipboard = () => {
		const { rows } = this.state;
		let text = '';
		rows.forEach((row) => {
			const { tmwOrderId } = row;
			text += tmwOrderId + '\n';
		});

		this.setState({
			snackbarMessage: `Copied ${rows.length} TMW #s to the clipboard`,
			snackbarIsOpen: true,
		});

		if (!navigator.clipboard) {
			this.fallbackCopyTextToClipboard(text);
			return;
		}
		navigator.clipboard.writeText(text).then(
			function () {},
			function (err) {
				console.error('Async: Could not copy text: ', err);
			}
		);
	};

	fallbackCopyTextToClipboard(text) {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			const successful = document.execCommand('copy');
			const msg = successful ? 'successful' : 'unsuccessful';
			console.warn('Fallback: Copying text command was ' + msg);
		} catch (err) {
			console.error('Fallback: Oops, unable to copy', err);
		}

		document.body.removeChild(textArea);
	}
}

UnbilledOrdersList.propTypes = {
	searchUnbilledOrders: PropTypes.func.isRequired,
	//userMap : PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), AuthUserContainer, TmwApi])(UnbilledOrdersList);
